"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THREAD_EVENT_TYPES = [
    "STATUS_UPDATED",
    "MESSAGE_CREATED",
    "PRIORITY_UPDATED",
    "SUBJECT_UPDATED",
];
//# sourceMappingURL=thread-event-type.js.map